import { useTranslation } from 'react-i18next'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { generatePath } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'


import stylesLayout from '@pages/catalog/ui/styles.module.scss'

import { CarouselCategoriesPreview, useCategorySlug } from '@entities/Categories'

import { CartPreview } from '@features/cart'
import { useAddressStore } from '@features/shipping-methods'

import { CategoriesBranch } from '@widgets/categories-branch'
import { ProductCarousel } from '@widgets/product-carousel'




import SEO from '@shared/components/SEO'
import { URL_PAGE_CATALOG, URL_PAGE_CATALOG_2ND_LVL } from '@shared/contants'
import { BRAND_NAME } from '@shared/contants/app'
import {
  Product,
  useCategoriesPreviewProductsQuery,
  useCategoryQuery,
} from '@shared/generated'
import { cn } from '@shared/lib/cn'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

function ProductCategoryCarouselLoading () {
  return (
    <SkeletonTheme>
      <Skeleton
        count={6}
        width={'100%'}
        style={{
          borderRadius: 12,
          aspectRatio: '4/1',
          marginBottom: 56,
        }}
      />
    </SkeletonTheme>
  )
}

export default function CategoryCatalogPage () {
  const { t: tn } = useTranslation('navigation')
  const { t: ts } = useTranslation('seo')
  const isTablet = useMediaQuery('(max-width: 991px)')
  const categorySlug = useCategorySlug()
  const { shopId } = useAddressStore()

  const { data: category, loading } = useCategoryQuery({
    variables: {
      shopId: shopId,
      slug: categorySlug,
    },
  })

  const { data: childrenCategories, loading: childrenCategoriesLoading } =
    useCategoriesPreviewProductsQuery({
      variables: {
        shopId: shopId,
        parentId: category?.category?.id,
      },
      skip: !category?.category?.id,
      fetchPolicy: 'cache-and-network',
    })


  const makePath = (slug: string) => generatePath(URL_PAGE_CATALOG_2ND_LVL, {
    categorySlug: category?.category?.slug as string,
    categoryChildrenSlug: slug
  })

  return (
    <Container>
      <SEO
        title={category?.category?.name ? `${category.category.name} | ${BRAND_NAME}` : ts('catalog.title', { brand: BRAND_NAME })}
        description={category?.category?.name ? ts('catalog.categoryDescription', { category: category.category.name, brand: BRAND_NAME }) : ts('catalog.description', { brand: BRAND_NAME })}
      />
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <div className={stylesLayout.grid}>
            <Breadcrumbs
              className={stylesLayout.breadcrumbs}
              links={[
                {
                  title: tn('catalog'),
                  to: URL_PAGE_CATALOG,
                },
                {
                  title: category?.category?.name as string,
                },
              ]}
            />
            {!isTablet && (
              <div className={stylesLayout.aside}>
                <CategoriesBranch className={stylesLayout.aside__content} />
              </div>
            )}
            <div className={cn(stylesLayout.content, styles.content)}>
              <h1 className={styles.root__title}>{category?.category?.name}</h1>

              {childrenCategories && (
                <CarouselCategoriesPreview
                  className={styles['categories-top']}
                  data={childrenCategories}
                  parentCategorySlug={category?.category?.slug as string}
                />
              )}

              <div className={styles['grid']}>
                {!childrenCategoriesLoading &&
                  childrenCategories?.categories?.map((item) => {
                    return (
                      <ProductCarousel
                        products={(item?.products as Product[]) || []}
                        loading={loading}
                        title={item?.name as string}
                        link={makePath(item?.slug as string)}
                        key={item?.id}
                      />
                    )
                  })}

                {childrenCategoriesLoading && (
                  <ProductCategoryCarouselLoading />
                )}
              </div>
            </div>
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
